var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.999,
    height: 28.295,
    viewBox: "0 0 31.999 28.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M2.46,4.781V8.31h3.5C4.8,7.125,3.624,5.943,2.46,4.781m2.646-.832h0a16.212,16.212,0,0,1,22.11.842,16.383,16.383,0,0,1,0,23.14,1.208,1.208,0,0,1-1.728,0,1.234,1.234,0,0,1,0-1.757,13.924,13.924,0,0,0,0-19.637A13.766,13.766,0,0,0,6.862,5.7L9.811,8.668a1.263,1.263,0,0,1-.019,1.75,1.219,1.219,0,0,1-.933.357H1.221A1.223,1.223,0,0,1,0,9.539V1.8A1.222,1.222,0,0,1,1.221.554,1.241,1.241,0,0,1,2.157.99Z",
    fill: "#35424b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.2ae28570a16d714b25656f0b9ded4167.svg";
export { ForwardRef as ReactComponent };